import { ReportAllocatedAndSubsidies38Container } from "../../../containers/SupportSystem/Reports/ReportAllocatedAndSubsidies38Container";
export function ReportAllocatedAndSubsidies38Page() {
    return (
        <ReportAllocatedAndSubsidies38Container />
    );

}